import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Button } from "../components/ui/button";
import { faqs } from "../mock/mockData";
import { ArrowLeft } from "lucide-react";

export default function Faqs() {
  const location = useLocation();
  const fromDashboard = location.state?.fromDashboard || document.referrer.includes('/dashboard');

  return (
    <div className="space-y-8">
      {fromDashboard && (
        <Link to="/dashboard">
          <Button variant="outline" size="sm" className="border-[#d5c39d] text-[#182033] hover:bg-[#f5ebd9]">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </Link>
      )}

      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Frequently Asked Questions</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          The questions below address common queries about registration, examination modes and certification. Further information will be available through official documentation and support channels.
        </p>
      </section>

      <section className="rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl sm:p-6">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((item, index) => (
            <AccordionItem key={item.question} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-sm font-semibold text-slate-900">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-700">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
